import { createAction } from 'redux-actions';
import { getSectionHistoryRequest } from 'api/sections-api';

export const fetchSectionReviewsHistoryLoaded = createAction(
  'FETCH_SECTION_REVIEWS_HISTORY_LOADED',
);

export const fetchSectionReviewsHistoryLoading = createAction(
  'FETCH_SECTION_REVIEWS_HISTORY_LOADING',
);

export const fetchSectionReviewsHistoryError = createAction(
  'FETCH_SECTION_REVIEWS_HISTORY_ERROR',
);

export const appendSectionReviewHistory = createAction(
  'APPEND_SECTION_REVIEW_HISTORY',
);

export const fetchSectionHistoryDetails =
  ({ revisionId, sectionId, isOCR }) =>
  async (dispatch) => {
    dispatch(fetchSectionReviewsHistoryLoading());
    await dispatch(
      fetchSectionHistoryDetailsWithoutLoading({
        revisionId,
        sectionId,
        isOCR,
      }),
    );
  };

export const fetchSectionHistoryDetailsWithoutLoading =
  ({ revisionId, sectionId, isOCR }) =>
  async (dispatch) => {
    try {
      const response = await getSectionHistoryRequest({
        revisionId,
        sectionId,
        isOCR,
      });
      dispatch(fetchSectionReviewsHistoryLoaded({ response }));
    } catch (error) {
      dispatch(fetchSectionReviewsHistoryError(error));
    }
  };
